import { Apis } from '../app.constants';
import APIService from '../../Services/APIService';

const HomeActions = () => {

  const getProposals = async ({ account_id }: { account_id: string }) => {
    const res = await APIService.get(`${Apis.getProposalsList}?account_id=${account_id}`);
    return res;
  };

  //   const getOrganisationMap = async ({ source_organisation_id, next_page, search }: { source_organisation_id: string, next_page: number, search: string }) => {
  //     try {
  //         const url = `/v0/ui/website/organisation-map/?source_organisation_id=${source_organisation_id}&next_page=${next_page}&search=${search || ''}`;
  //         const res = await APIService.get(url);

  //         if (res.status === 200) {
  //             return res;
  //         } else {
  //             console.error('Error: Failed to fetch data', res);
  //             return { status: 'error', message: `Failed to fetch data: ${res.statusText}`, error: res.data };
  //         }
  //     } catch (error) {
  //         console.error('Error fetching organisation map:', error);

  //         if (error.response) {
  //             console.error('API response error:', error.response.data);
  //         }

  //         return { status: 'error', message: 'Failed to fetch organisation map data', error };
  //     }
  // };




  const getProposalById = async (proposalId: string) => {
    try {
      const res = await APIService.get(`v0/ui/website/proposal/${proposalId}/`);
      return res;
    } catch (error) {
      console.error('Error fetching proposal by ID:', error);
      throw error;
    }
  };

  const getShortlistedSuppliers = async (proposalId: string) => {
    try {
      const res = await APIService.get(`v0/ui/website/proposal/${proposalId}/shortlisted_suppliers/`);
      return res;
    } catch (error) {
      console.error('Error fetching shortlisted suppliers:', error);
      throw error;
    }
  };


  const createAccount = async (data) => {
    try {
      let res = await APIService.post("v0/ui/website/account/", data);
      return res;
    } catch (error) {
      console.log(error);
    }
  };

  const updateAccount = async (accountId, data) => {
    try {
      let res = await APIService.put(`${Apis.updateAccount}${accountId}/`, data);
      return res;
    } catch (error) {
      console.error(error);
    }
  };
  const getAccountDetailsById = async (accountId) => {
      let res = await APIService.get(`${Apis.updateAccount}${accountId}/`);
      return res;
  };


  const loadInitialSupplierData = async () => {
    try {
      const res = await APIService.get('v0/ui/create_supplier/load_initial_data/');
      return res;
    } catch (error) {
      console.error('Error loading initial supplier data:', error);
      throw error;
    }
  };

  const getSupplierAgencies = async () => {
    try {
      const res = await APIService.get('v0/ui/website/organisation/?category=SUPPLIER_AGENCY');
      return res;
    } catch (error) {
      console.error('Error fetching supplier agencies:', error);
      throw error;
    }
  };

  const getAreasByLocation = async (locationId) => {
    try {
      const res = await APIService.get(`v0/ui/locations/${locationId}/?type=areas`);
      return res;
    } catch (error) {
      console.error(`Error fetching areas for location ${locationId}:`, error);
      throw error;
    }
  };

  const getSubAreasByArea = async (areaId) => {
    try {
      const res = await APIService.get(`v0/ui/locations/${areaId}/?type=sub_areas`);
      return res;
    } catch (error) {
      console.error(`Error fetching sub-areas for area ${areaId}:`, error);
      throw error;
    }
  };

  const createInitialProposal = async (accountId, data) => {
    try {
      const res = await APIService.post(`v0/ui/website/${accountId}/create-initial-proposal/`, data);
      return res;
    } catch (error) {
      console.error('Error creating initial proposal:', error);
      throw error;
    }
  };


  const getSupplierInventoryList = async (proposal_id: string, do_not_query_by_date: string) => {

    try {

      const res = await APIService.get(`/v0/ui/website/campaigns-suppliers-inventory-list/?proposal_id=${proposal_id}&do_not_query_by_date=1`);

      return res;

    } catch (error) {

      console.error('Error fetching proposal by ID:', error);

      throw error;

    }

  };




  return {
    getProposals,
    createAccount,
    updateAccount,
    getAccountDetailsById,
    getProposalById,
    getShortlistedSuppliers,
    loadInitialSupplierData,
    getSupplierAgencies,
    getAreasByLocation,
    getSubAreasByArea,
    createInitialProposal,
    getSupplierInventoryList,
    // getOrganisationMap,  
  };
};

export { HomeActions };